import React, { useState } from 'react';
import Logo from '../../assets/images/main-logo.png';
import FooterLogo from '../../assets/images/footer_logo.jpg';
import { Link } from 'react-router-dom';
import { axiosInstance, config } from '../pages/config';
import { notification } from 'antd';
import Loader from '../common/Loader';

const Footer = () => {
  const Year = new Date().getFullYear();
  const [email, setemail] = useState('');
  const [Loading, setLoading] = useState(false);

  const handlesubmit = async () => {
    if (email !== '') {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`newsletter`, {
          email: email,
        });
        if (response?.data?.status === 1) {
          if (response?.data?.message === 'Email is already subscribed.') {
            notification.open({
              message: (
                <div className="d-flex">
                  <div className="pr-20">
                    <i
                      className="bi bi-check2-circle text-success"
                      style={{ fontSize: '20px' }}
                    ></i>
                  </div>
                  <div>You are Already Subscribed</div>
                </div>
              ),
            });
          } else {
            notification.open({
              message: (
                <div className="d-flex">
                  <div className="pr-20">
                    <i
                      className="bi bi-check2-circle text-success"
                      style={{ fontSize: '20px' }}
                    ></i>
                  </div>
                  <div>Email Submitted Successfully</div>
                </div>
              ),
            });
          }

          setemail('');
          setLoading(false);
        } else {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-exclamation-circle-fill text-danger"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: 'Try Again !',
          });
          setemail('');
        }
      } catch (e) {
        setLoading(false);
      }
    } else {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-20">
              <i
                className="bi bi-exclamation-circle-fill text-danger"
                style={{ fontSize: '20px' }}
              ></i>
            </div>
            <div>Please Enter an Email.</div>
          </div>
        ),
      });
    }
  };

  return (
    <div>
      {Loading && <Loader />}
      <footer
        id="rs-footer"
        className="rs-footer footer-style1 footer-style4"
        style={{ backgroundColor: '#07422c' }}
      >
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12 md-mb-20 pr-83 md-pr-15">
                    <div className="footer-logo mb-30 md-mb-20">
                      <Link to={`${config.appUrl}`}>
                        <img src={Logo} alt="" width="192" height="40" />
                      </Link>
                    </div>
                    <div className="textwidget mb-33">
                      Delivering exceptional cleaning solutions tailored to your
                      unique needs. From offices to commercial spaces, we ensure
                      every corner shines with precision and care.
                    </div>

                    {/* <ul className="footer-social mb-3">
                                            <li>
                                                <a className='' target='_blank' href='https://www.facebook.com/login/'><i className='bi bi-facebook '></i></a>
                                            </li>
                                            <li>
                                                <a target='_blank' href='https://www.instagram.com/accounts/login/'><i className='bi bi-instagram '></i></a>
                                            </li>
                                            <li>
                                                <a href='https://x.com/login' target='_blank'><i className='bi bi-twitter-x '></i></a>
                                            </li>
                                            <li>
                                                <a href='https://www.linkedin.com/login' target='_blank'><i className='bi bi-linkedin '></i></a>
                                            </li>
                                        </ul> */}
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 md-mb-20 d-flex justify-content-between my-4 my-xl-0 px-3 px-xl-0">
                    <div>
                      <h3 className="footer-title">Quick Link</h3>
                      <ul
                        className="address-widget ps-0"
                        style={{ listStyle: 'outside none' }}
                      >
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}`}>Home</Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}about-us`}>
                              About Us
                            </Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}services`}>
                              Our Services
                            </Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}case-studies`}>
                              Case Studies
                            </Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}news-and-update`}>
                              News & Update
                            </Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}contact-us`}>
                              Contact Us
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <h3 className="footer-title">Policies</h3>
                      <ul
                        className="address-widget ps-0"
                        style={{ listStyle: 'outside none' }}
                      >
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}privacy-policy`}>
                              Privacy Policy
                            </Link>
                          </div>
                        </li>
                        <li>
                          <i className="bi bi-chevron-right"></i>
                          <div className="desc">
                            <Link to={`${config.appUrl}terms-conditions`}>
                              Terms & Conditions
                            </Link>
                          </div>
                        </li>
                      </ul>
                      {/* BICSC Digital Badge + Footer Logo */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '20px',
                          marginTop: '35px',
                        }}
                      >
                        <div
                          style={{
                            position: 'relative',
                            width: '90px',
                            height: '90px',
                            overflow: 'hidden',
                          }}
                        >
                          <iframe
                            frameBorder="0"
                            scrolling="no"
                            allowTransparency="true"
                            src="https://cdn.yoshki.com/iframe/55990r.html"
                            style={{
                              border: 0,
                              margin: 0,
                              padding: 0,
                              backgroundColor: 'transparent',
                              top: '50%',
                              left: '50%',
                              width: '188px',
                              height: '90px',
                              position: 'absolute',
                              transform: 'translate(-50%, -50%)',
                            }}
                            title="BICSC Digital Badge"
                          />
                        </div>
                        <div
                          style={{
                            width: '1px',
                            height: '70px',
                            backgroundColor: 'rgba(255,255,255,0.4)',
                          }}
                        ></div>
                        <img
                          src={FooterLogo}
                          alt="SafeContractor Approved"
                          style={{
                            height: '90px',
                            width: '90px',
                            objectFit: 'contain',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 md-mb-20 pl-90 md-pl-15">
                <h3
                  className="footer-title black-title text-white"
                  style={{ textTransform: 'capitalize' }}
                >
                  Get hooked! sign up to get the latest offers and discounts
                  sent directly to your inbox
                </h3>
                <div className="footer-email-field">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                    required=""
                  />
                  <button className="text-white" onClick={handlesubmit}>
                    <i className="bi bi-arrow-right text-dark fs-4"></i>{' '}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom" style={{ background: '#07422c' }}>
          <div className="container">
            <div className="d-flex y-middle justify-content-center">
              <div className="text-center">
                <div className="copyright text-lg-start text-center ">
                  <p className="text-white">
                    Copyright © {Year} Precision Contract Cleaning Services
                    Limited. Designed By{' '}
                    <a
                      href="https://www.zithas.co.uk"
                      target="blank"
                      className="fw-600"
                      style={{ color: '#ffd600' }}
                    >
                      {' '}
                      Zithas Technologies
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
